/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { NavbarV2 as Nav } from '@bitcoin-portal/navbar';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { HeadSection } from './styled';
import SEO from '../../components/SEO';
import Header from './Header';
import BuySellTrade from './BuySellTrade';
import ERC from './ERC';
import MoveMoney from './MoveMoney';
import Markets from './Markets';
import Security from './Security';
import GetStarted from './GetStarted';
import Subscribe from '../Token/SubscribeV2/Subscribe';
import { appLocales } from '../../i18n';
import WalletsCreated from './WalletsCreated';
import Rewards from './Rewards';
import Features from './Features/Features';
import NavbarHome from '../../components/Navbar/NavbarHome';
import Footer from '../../components/FooterComponent/Footer';
import Whathow from './WhatHow';
import { useBranchLink } from '../../helpers/branchLink';

const Home = ({ locale, template }) => {
  const { messages } = useIntl();
  const mobileButtonLink = useBranchLink({
    branch: messages[`${template}.header.link.mobile_button`],
    android: messages[`${template}.header.link.googleplay`],
    iOS: messages[`${template}.header.link.appstore`],
    fallback: messages[`${template}.header.link.mobile_button`],
  });

  const isERC20Token =
    template !== 'bitcoin' &&
    template !== 'bitcoin-cash' &&
    template !== 'zano';
  return (
    <>
      <Helmet>
        <script
          src={
            process.env.MPC_WIDGET_URL ||
            'https://widget.bitcoin.com/widget.v0.7.14.iife.js'
          }
          type="text/javascript"
        />
        <link
          rel="preconnect"
          href="https://fonts.bitcoin.com/Elza/Elza_Condensed_Black/crossmedia/Elza-CondensedBlack.woff"
          as="font"
          type="font/woff"
          crossOrigin="anonymous"
        />
        <link
          rel="preconnect"
          href="https://fonts.bitcoin.com/Satoshi_Variable/Fonts/WEB/fonts/Satoshi-Medium.woff"
          as="font"
          type="font/woff"
          crossOrigin="anonymous"
        />
        <link
          rel="preconnect"
          href="https://fonts.bitcoin.com/Chivo_Mono/ChivoMono-VariableFont_wght.ttf"
          as="font"
          type="font/ttf"
          crossOrigin="anonymous"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@500..900&family=Noto+Sans:ital,wdth,wght@0,75..100,500..900;1,62.5..100,500..900&display=swap"
          rel="stylesheet"
          key="google-fonts2"
        />

        <style>
          {`
                  @font-face {
                    font-family: 'Elza Condensed';
                    src: url('https://fonts.bitcoin.com/Elza/Elza_Condensed_Black/crossmedia/Elza-CondensedBlack.woff') format('woff');
                    font-style: normal;
                    font-display: swap;
                  }
                  @font-face {
                    font-family: 'Satoshi Variable Medium';
                    src: url('https://fonts.bitcoin.com/Satoshi_Variable/Fonts/WEB/fonts/Satoshi-Medium.woff') format('woff');
                    font-weight: normal;
                    font-style: normal;
                    font-display: swap;
                  }
                  @font-face {
                    font-family: 'Chivo Mono';
                    src: url('https://fonts.bitcoin.com/Chivo_Mono/ChivoMono-VariableFont_wght.ttf') format('truetype');
                    font-weight: normal;
                    font-style: normal;
                    font-display: swap;
                  }
                `}
        </style>
      </Helmet>
      <SEO page={template} canonicalPage={template === 'bitcoin' ? 'home' : undefined} />
      <NavbarHome locale={locale} />
      <Header locale={locale} template={template} />
      <Features template={template} />
      <Whathow locale={locale} template={template} />
      <Rewards
        template={template}
        locale={locale}
        mobileButtonLink={mobileButtonLink}
      />
      {template === 'bitcoin' && <GetStarted template={template} />}
      <Subscribe />
      <Footer />
    </>
  );
};

Home.propTypes = {
  locale: PropTypes.string.isRequired,
  template: PropTypes.string.isRequired,
};

export default Home;
